<template>
  <div class="NetworkSection">
    <div class="wrapper" :style="sectionStyle">
      <div class="num" :style="numStyle">
        {{num}}
      </div>
      <div class="description">
        {{text}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NetworkSection',
    data(){
      return {
      }
    },
    components:{
    },
    props: {
      id: {
        type: Number,
        default: ""
      },
      num: {
        type: String,
        default: ""
      },
      text: {
        type: String,
        default: ""
      },
      color: {
        type: String,
        default: "#000"
      }
    },
    computed: {
      sectionStyle(){
        return {
          borderTop: `4px solid ${this.color}`
        }
      },
      numStyle(){
        return{
          color: this.color
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';
  .wrapper{
    @media (max-width:  @bootstrap-lg - 1px){
      padding-top: 25px;
      padding-bottom: 40px;
      padding-left: 15px;
      padding-right: 15px;
    }
    padding-top: 50px;
    padding-bottom: 80px;
    padding-left: 25px;
    padding-right: 60px;
    background: #fff;
    height: auto;
  }

  .description{
    font-size: 18px;
    font-weight: 300;
    line-height: 30px;
    @media (max-width:  @bootstrap-lg - 1px){
      font-size: 16px;
      line-height: 22px;
    }
  }

  .num{
    font-family: Futura,Trebuchet MS,Arial,sans-serif; 
    font-size: 110px;
    font-weight: 700;
    @media (max-width:  @bootstrap-lg - 1px){
      font-size: 70px;  
    }
  }

</style>
